import React from 'react';
import { Bar } from 'react-chartjs-2';
import Box from '@mui/material/Box';

import { useMetrics } from '../../Contexts/metrics-context';
import { getPacketsProcessedRejectedPerOperator } from '../../Utils/metricsSerializer';
import chartColors from './../../Constants/colors';
import defaultGraphOptions from './../../Constants/defaultGraphOptions';
import ChartWrapper from './ChartWrapper';
import { Capitalize } from '../../Utils/util';

export default function ChartPacketsProcessedRejectedPerOperator({ dataType }: { dataType: string }) {
  const { stateMetrics } = useMetrics();
  const packetsProcessedRejectedPerSat = getPacketsProcessedRejectedPerOperator(
    stateMetrics.metricsOutput,
    stateMetrics.metricsErrors,
    dataType
  );

  const labelsChart = packetsProcessedRejectedPerSat.operatorsUnique;

  const dataMonthsProp = {
    labels: labelsChart,
    datasets: [
      {
        label: 'Processed',
        data: labelsChart.map(
          (value) =>
            packetsProcessedRejectedPerSat.packetsProcessedPerOperator[value],
        ),
        backgroundColor: chartColors.barCharts.backgrounds[0],
      },
      {
        label: 'Rejected',
        data: labelsChart.map(
          (value) =>
            packetsProcessedRejectedPerSat.packetsRejectedPerOperator[value],
        ),
        backgroundColor: chartColors.barCharts.backgrounds[1],
      },
    ],
  };

  return (
    <React.Fragment>
      <ChartWrapper  title={Capitalize(dataType)+ " per operator"}>
        <Box style={{ height: '400px', margin: 'auto' }}>
          <Bar options={defaultGraphOptions.bar} data={dataMonthsProp} />
        </Box>
      </ChartWrapper>
    </React.Fragment>
  );
}
